module.exports = __webpack_public_path__ + "static/img/screens-map.a4b72de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/screens-map.png
// module id = 9v5C
// module chunks = 1